
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/Euler/HiLoadDV",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/Euler/HiLoadDV/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/Euler/HiLoadDV"])
      });
    }
  